import React from 'react';
import logoImg from '../images/logo.png';
import { Link } from 'react-router-dom';

export default function Navbar() {
    let isLogin = localStorage.getItem("blockstardao");
    return (
        <nav className="navbar navbar-light container">
            <a className="navbar-brand" href="#">
                <img src={logoImg} className='landing-logo' alt='logo' />
            </a>
            <div className="ms-auto">
                {(isLogin === null || isLogin === 'null') ? (
                    <a href='https://blockstar.social/oauth?app_id=c47fcfe9736964bf08c2' className="btn btn-primary px-3 py-1 my-2 my-sm-0">
                        Login
                    </a>
                ) : (
                    <Link to='/dashboard' className="btn btn-primary px-3 py-1 my-2 my-sm-0">
                        DashBoard
                    </Link>
                )}
            </div>
        </nav>
    );
}
